import { FormaPagamentoEnum } from "../../../../../enums/formaPagamento";
import { FormaPagamentoDisponivel } from "../../useBatchSpreadsheetImport";

interface IPaymentMethodSelectorProps {
  value: FormaPagamentoDisponivel;
  onChange: (value: FormaPagamentoDisponivel) => void;
}

const OPCOES = [
  { value: FormaPagamentoEnum.PIX, label: "Pix" },
  { value: FormaPagamentoEnum.BOLETO, label: "Boleto" },
] as const;

/**
 * Pix/Boleto radio selection for the batch spreadsheet import page — kept
 * page-local (not an Atom) since this exact 40px circular-radio visual has
 * no other consumer; `PaymentV2`'s own Pix/Boleto selector uses large
 * selectable cards instead, a different shape with nothing to share here.
 * Selected/unselected colors and icon geometry are exact exports from the
 * Figma "Radio" component, not tenant-colored.
 */
export const PaymentMethodSelector = ({
  value,
  onChange,
}: IPaymentMethodSelectorProps) => {
  return (
    <div className="flex flex-col gap-4 rounded-3xl border border-solid border-[#adb7b5] bg-white px-8 py-6 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)] md:flex-row md:items-center md:gap-0 md:py-0 mt-8">
      <p className="font-['Mulish'] text-base font-bold text-[#20332f] md:w-[379px] md:shrink-0 md:px-[15px]">
        Selecione a forma de pagamento das faturas:
      </p>
      <div className="flex flex-wrap items-center gap-2 md:gap-[15px] md:px-[15px]">
        {OPCOES.map(({ value: opcao, label }) => {
          const selecionado = value === opcao;

          return (
            <label
              key={opcao}
              className="flex cursor-pointer items-center gap-4 rounded-full px-4 py-2"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${
                  selecionado ? "bg-[#38b449]/10" : ""
                }`}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {selecionado ? (
                    <path
                      d="M12 21C7 21 3 17 3 12C3 7 7 3 12 3C17 3 21 7 21 12C21 17 17 21 12 21ZM12 19C15.9 19 19 15.9 19 12C19 8.1 15.9 5 12 5C8.1 5 5 8.1 5 12C5 15.9 8.1 19 12 19ZM12 16C14.2 16 16 14.2 16 12C16 9.8 14.2 8 12 8C9.8 8 8 9.8 8 12C8 14.2 9.8 16 12 16Z"
                      fill="#50D05D"
                    />
                  ) : (
                    <path
                      d="M12 21C7 21 3 17 3 12C3 7 7 3 12 3C17 3 21 7 21 12C21 17 17 21 12 21ZM12 19C15.9 19 19 15.9 19 12C19 8.1 15.9 5 12 5C8.1 5 5 8.1 5 12C5 15.9 8.1 19 12 19Z"
                      fill="#9D9D9D"
                    />
                  )}
                </svg>
              </span>
              <input
                type="radio"
                name="formaPagamento"
                className="sr-only"
                checked={selecionado}
                onChange={() => onChange(opcao)}
              />
              <span className="font-['Mulish'] text-sm font-bold leading-5 text-[#2d2d2d]">
                {label}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
};
